import { css } from "@emotion/css";

export const clickableRowCss = css`
    cursor: pointer;
`;
